import { memo } from 'react';
import { AccordionIdentityCard as AccordionIdentityCardVM } from 'shell/view-models/accordion-identity-card';
import { Divider, Grid } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import { FormikErrors, FormikTouched } from 'formik';

interface IdentityCardProps {
  values?: AccordionIdentityCardVM;
  onChange: (
    key: keyof AccordionIdentityCardVM,
    value: AccordionIdentityCardVM[keyof AccordionIdentityCardVM]
  ) => void;
  errors?: FormikErrors<AccordionIdentityCardVM>;
  touched?: FormikTouched<AccordionIdentityCardVM>;
}

const ConsulateReleaseComponent = ({
  values,
  onChange,
  errors,
  touched,
}: IdentityCardProps): React.ReactElement => {
  return (
    <Grid container item spacing={2}>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Consolato rilascio</PmiTitleDivider>
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Codice consolato"
          aria-label="Codice consolato"
          fullWidth
          onChange={(event) => {
            onChange('consulateCode', event?.target.value);
          }}
          value={values?.consulateCode || ''}
          error={touched?.consulateCode && !!errors?.consulateCode}
          helperText={errors?.consulateCode}
        />
      </Grid>
    </Grid>
  );
};

ConsulateReleaseComponent.displayName = 'Consulate Release component';

const ConsulateRelease = memo(ConsulateReleaseComponent);

export default ConsulateRelease;
